import { Field } from '~/eds/src/modules/Form/types';
import { EntityType } from '~/enums/EntityType';
import { intlService } from '~/i18n/IntlService';

import type { EntityVisibilityType } from './types';

export const getUserDepartmentArray = (
  entityVisibility: EntityVisibilityType,
) => {
  if (entityVisibility) {
    const { departmentIds = [], userIds = [] } = entityVisibility;
    const depObjs = departmentIds.map((id) => ({
      id,
      role: null,
      type: EntityType.Department,
    }));
    const userObjs = userIds.map((id) => ({
      id,
      role: null,
      type: EntityType.User,
    }));
    return [...depObjs, ...userObjs];
  }
  return [];
};

export const validateShareField = (field: Field, value: unknown) => {
  if (field.name === 'shareField') {
    const { visibility, userIds, departmentIds } = value as {
      visibility: 'OPEN' | 'PRIVATE' | 'SHARED';
      userIds: number[];
      departmentIds: number[];
    };
    if (
      visibility === 'SHARED' &&
      (!userIds || userIds.length === 0) &&
      (!departmentIds || departmentIds.length === 0)
    ) {
      const intl = intlService.getIntl();
      return intl.formatMessage({
        id: 'EntityVisibilitySelect.selectUserOrDepartment',
        defaultMessage: 'Please select at least one user or department',
        description:
          'Validation message when no users or departments are selected for sharing',
      });
    }
  }
  return null;
};
